import {useCallback, useEffect, useRef, useState} from "react";
import Form, {AsyncRule, ButtonItem, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {db, storage} from '../../../../firebase/Firebase';
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {Layout, LayoutChild} from "../../../../palette/Palette";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {Filters, Order, MakePwd} from '../../../../utils/HelpFunctions';
import Alerts from "../../../../palette/Alerts";
import format from 'date-fns/format'
import {makeStyles} from '@material-ui/core/styles';
import FileUploader from 'devextreme-react/file-uploader';
import ProgressLabel from "../../../../palette/Progress";
import Avatar from '@material-ui/core/Avatar';
import {LocalTaxi} from '@material-ui/icons';
import RoutesSchedulesList from "./RoutesSchedulesList";
import addHours from 'date-fns/addHours';
import addMinutes from 'date-fns/addMinutes';
import {Button} from "devextreme-react/button";
import {customScroll} from "../../../../utils/Scroll";
import {Element} from 'react-scroll'
import axios from 'axios'
import ComponentLoadPanel from '../../../../palette/LoadPanel';

const dataVehicle = {
    brand: '',
    model: '',
    color: '',
    plateNumber: '',
    typeVehicle: '',
    route: '',
    day: '',
    hour: '',
};

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true
        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

const vehiclesBrands = ['CHEVROLET', 'FIAT', 'KIA', 'HYUNDAI', 'NISSAN', 'RENAULT', 'TOYOTA', 'VOLVO', 'MERCEDES', 'FORD',
    'PEUGEOT', 'CITROEN', 'VOLKSWAGEN', 'AUDI', 'HONDA', 'GREAT WALL', ' MITSUBISHI', 'MAZDA'];

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://driver-account-easi4xatjq-uc.a.run.app/driver-account';

//const url = 'http://localhost:8081/driver-account'

const controlPlateChar = /^[A-Z0-9]+$/i

function VehicleForm(props) {

    const {
        dataDrivers, setTrigger, trigger, DataStore, setDataDrivers, dataDriversArray, setVisibleForm, setVisibleGrid,
        visibleForm, ControlStore
    } = props;

    const {companyName, idCompany, imageAsUrl, contactNumbers} = DataStore

    const [submitButton,] = useState({...buttonSuccess, text: 'Guardar datos'})
    const [success, setSuccess] = useState(false)
    const [progressImage, setProgressImage] = useState(0);
    const [filePhoto, setFilePhoto] = useState('No se ha selecionado ninguna imagen');
    const [imageVehicleAsUrl, setImageVehicleAsUrl] = useState(null);
    const [typeVehicle, setTypeVehicle] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [routesSchedules, setRoutesSchedules] = useState([]);
    const [dataDays, setDataDays] = useState([]);
    const [valueRoutes, setValueRoutes] = useState('');
    const [valueDays, setValueDays] = useState('');
    const [valueHour, setValueHour] = useState('');
    const [dataHour, setDataHour] = useState([]);
    const [dataRoute, setDataRoute] = useState([]);
    const [nextHour, setNextHour] = useState('');
    const [showPanel, setShowPanel] = useState(false);
    const [prevDay, setPrevDay] = useState('');
    const [isImage, setIsImage] = useState(true)
    const [alert, setAlert] = useState(false)
    const [textAlert, setTextAlert] = useState('')
    const [alertImage, setAlertImage] = useState(false)

    const classes = useStyles();

    const isMounted = useMountedState()
    const {enqueueSnackbar} = useSnackbar();
    const dxForm = useRef(null);

    const mainPath = db.collection(companyName).doc(idCompany);

    useEffect(() => {
        const GetTypesVehicles = async () => {
            const newArray = [];
            await mainPath.collection('TypesVehicles')
                .where('state', '==', 'Activo')
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if (doc.exists) {
                            const obj = {...doc.data(), docId: doc.id};
                            newArray.push(obj);
                        } else {
                            setTypeVehicle([]);
                        }
                    });
                    setTypeVehicle(newArray);
                });
        };


        if (isMounted()) {
            GetTypesVehicles().catch(function () {
                NotiStackInfo('Error inesperado', 'error', enqueueSnackbar);
            });
        }


    }, [companyName, idCompany, isMounted]);

    useEffect(() => {
        const GetRoutes = async () => {
            const data = [];
            await db.collection(companyName).doc(idCompany).collection('Data-Routes')
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const obj = {...doc.data(), id: doc.id};
                        data.push(obj);
                    });
                    const newArr = data.filter((el, index) => data.indexOf(el) === index);
                    setRoutesSchedules([...newArr]);
                });
        };
        if (isMounted()) {
            GetRoutes().catch(function () {
                NotiStackInfo('Error inesperado', 'error', enqueueSnackbar);
            });
        }
    }, [companyName, enqueueSnackbar, idCompany, isMounted]);

    const renderAlert = () => {
        return (
            <Alerts severity={'error'} body={textAlert}/>
        )
    }
    const renderSuccess = () => {
        return (<Alerts severity="success" body={'Conductor creado exitosamente'}/>
        )
    }
    const renderCancelButton = () => {
        const {instance} = dxForm.current
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        instance.resetValues()
                        setVisibleForm(false)
                        setVisibleGrid(true)
                    }}/>
        )
    }

    /*Subir imagen*/
    const imageVehicleRender = () => {
        return (
            <Layout color="transparent" positionR center>
                {imageVehicleAsUrl ? <Avatar alt="" src={imageVehicleAsUrl} className={classes.large}/> :
                    <Avatar alt="" className={classes.large}>
                        <LocalTaxi/>
                    </Avatar>
                }
            </Layout>
        );
    };
    const uploadVehiclePhoto = () => {
        return (
            <Layout color={'transparent'}>
                <Layout color={'transparent'} center row positionL>
                    <LayoutChild color={'transparent'} center row width="auto">
                        <FileUploader multiple={false} accept={'*'} uploadMode={'instantly'}
                                      inputAttr={{id: 'upload-buttons'}} selectButtonText={'Seleccionar imagen'}
                                      showFileList={false} onValueChanged={onSelectedImageFilesChanged}
                                      labelText={filePhoto}/>
                    </LayoutChild>
                </Layout>
                {progressImage > 0 && <ProgressLabel progress={progressImage}/>}
                {!isImage && <Alerts severity={'warning'} body={'Solo se permiten imágenes'}/>}
                {alertImage > 0 &&
                <Alerts severity={'error'} body={'Debe cargar una imagen para para guardar los datos'}/>}
            </Layout>
        );
    };
    const onSelectedImageFilesChanged = (e) => {

        const arrayExt = ['jpg', 'jpeg', 'png'];
        const extension = e.value[0].name.split('.').pop();
        const found = arrayExt.find(element => element === extension);

        if (found) {
            const bucketPath = `${companyName}/drivers/vehicle-pic/${dataDrivers.idUser}/${e.value[0].name}`;
            setFilePhoto(e.value[0].name);
            setFilePhoto(`${e.value[0].name}`);

            const storageRef = storage.ref(bucketPath);
            const task = storageRef.put(e.value[0]);

            task.on('state_changed', (snapshot) => {
                let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setProgressImage(percentage)
                setFilePhoto(`${e.value[0].name}`);
            }, () => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            }, () => {

                storage.ref(`${companyName}/drivers/vehicle-pic/${dataDrivers.idUser}/`)
                    .child(e.value[0].name).getDownloadURL()
                    .then(async fireBaseUrl => {
                        setImageVehicleAsUrl(fireBaseUrl);
                        setFilePhoto(`Carga completa.`);
                        setProgressImage(0);
                        setAlertImage(false)
                    });
            });
        } else {
            setIsImage(false);
        }
    };

    /*Placa*/
    function sendRequest(value) {
        const plateNumberArr = []
        dataDriversArray.forEach((driver) => {
            plateNumberArr.push(driver.vehicleData.plateNumber)
        })

        const resultPlate = plateNumberArr.filter(plateNumber => plateNumber === value)

        if (controlPlateChar.test(value)) {
            if (resultPlate.length > 0) {
                return new Promise((resolve) => {
                    setTimeout(function () {
                        resolve(false);
                    }, 500);
                });
            } else {
                return new Promise((resolve) => {
                    setTimeout(function () {
                        resolve(true);
                    }, 500);
                });
            }
        } else {
            return new Promise((resolve) => {
                setTimeout(function () {
                    resolve(false);
                }, 1000);
            });
        }
    }

    const asyncValidation = (params) => {
        return sendRequest(params.value.toUpperCase());
    }

    const onValueChangedVehicle = () => {
        customScroll('list-element', 500)
    }

    /*Select routes*/
    const onValueChanged = async (e) => {
        const newArray = [];
        let id = 0;

        let route;
        if (e.value !== '' && e.value !== null) {
            const routeArr = e.value.split('-');
            route = `${routeArr[1]}-${routeArr[0]}`;
        }


        if (route !== e.previousValue) {
            setNextHour('');
        }


        setValueRoutes(e.value);
        await db.collection(companyName).doc(idCompany).collection('Routes')
            .where('routeName', '==', e.value).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    id = id + 1;
                    const obj = {...doc.data(), id: id};
                    newArray.push(obj);
                });

                const orderResult = Order(newArray, 'hour');
                setDataRoute(orderResult);
                setValueDays('');
                setValueHour('');
                const uniqueObjects = [...new Map(newArray.map(item => [item.days, item])).values()];
                const newDaysArr = [...uniqueObjects]
                newDaysArr.forEach(item => {
                    if (item.days === 'Lunes') {
                        item.ID = 1
                    }
                    if (item.days === 'Martes') {
                        item.ID = 2
                    }
                    if (item.days === 'Miercoles' || item.days === 'Miércoles') {
                        item.ID = 3
                    }
                    if (item.days === 'Jueves') {
                        item.ID = 4
                    }
                    if (item.days === 'Viernes') {
                        item.ID = 5
                    }
                    if (item.days === 'Sabado' || item.days === 'Sábado') {
                        item.ID = 6
                    }
                    if (item.days === 'Domingo') {
                        item.ID = 7
                    }
                })
                const orderDays = Order(newDaysArr, 'ID')
                setDataDays(orderDays);
            })
            .catch(function () {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            });
    };
    /*dia*/
    const onValueChangedDays = (e) => {

        if (e.value !== '') {
            setPrevDay(e.value);
        }

        let nextHourResult;
        if (nextHour !== '' && dataList.length > 0 && e.value !== '') {
            const filterDay = Filters(dataRoute, 'days', e.value);
            if (prevDay !== e.value) {
                nextHourResult = Filters(dataRoute, 'days', e.value);
            } else {
                nextHourResult = filterDay.filter(time => time.hour >= nextHour);
                nextHourResult = [...new Map(nextHourResult.map(item => [item.hour, item])).values()];
            }
        } else {
            nextHourResult = Filters(dataRoute, 'days', e.value);
        }
        setValueDays(e.value);
        setDataHour(nextHourResult);
    };
    /*hora*/
    const onValueChangedHours = async (e) => {

        if (visibleForm && dataHour.length > 0 && e.value !== '') {
            const listResult = Filters(dataHour, 'hour', e.value);

            const totalTime = listResult[0].breakTime + listResult[0].travelTime;
            const actualDate = format(new Date(), 'MM/dd/yyyy');

            const newArray = [...dataList];
            /*Horarios iguales*/
            const daysResult = Filters(dataList, 'days', valueDays);
            const hoursResult = Filters(daysResult, 'hour', e.value);

            if (hoursResult.length > 0) {
                return NotiStackInfo('No se pueden duplicar las rutas y horarios!', 'error', enqueueSnackbar);
            }

            let controlHours = false;

            if (dataList.length > 0) {
                dataList.forEach(item => {
                    const dateStr = `${actualDate}  ${item.hour}`;
                    const convertStrDate = new Date(dateStr);
                    const timeAdd = timeConvert(totalTime);

                    const sumHours = addHours(convertStrDate, timeAdd.hours);
                    const sumMinutes = addMinutes(sumHours, timeAdd.minutes);

                    const newHour = format(sumMinutes, 'HH:mm');

                    if ((item.hour < e.value) && (newHour > e.value) && (item.days === valueDays)) {
                        controlHours = true;
                    }

                    if (item.hour > e.value && item.days === valueDays) {
                        const hour = `${actualDate}  ${e.value}`;
                        const convertStrDateHour = new Date(hour);

                        const sumNewHours = addHours(convertStrDateHour, timeAdd.hours);
                        const sumNewMinutes = addMinutes(sumNewHours, timeAdd.minutes);

                        const newDataHour = format(sumNewMinutes, 'HH:mm');
                        if (newDataHour > item.hour || item.hour > e.value) {
                            controlHours = true;
                        }
                    }
                });
            }

            if (controlHours) {
                return NotiStackInfo('No se puede agregar esta ruta!', 'error', enqueueSnackbar);
            }

            newArray.push(listResult[0]);

            let index = 0;

            newArray.forEach(value => {
                index = index + 1;
                value.id = index;
                value.order = 1
            });

            setDataList(newArray);
            const route = dataVehicle.route.split('-');
            const reverseRoute = `${route[1]}-${route[0]}`;
            const dateStr = `${actualDate}  ${e.value}`;
            const convertDateStr = new Date(dateStr);
            const timeAdd = timeConvert(totalTime);

            const sumHours = addHours(convertDateStr, timeAdd.hours);
            const sumMinutes = addMinutes(sumHours, timeAdd.minutes);

            const newHour = format(sumMinutes, 'HH:mm');
            setNextHour(newHour);
            setValueRoutes(reverseRoute);

            let id = 0;

            const dataArray = [];
            await db.collection(companyName).doc(idCompany).collection('Routes')
                .get().then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        id = id + 1;
                        const obj = {...doc.data(), id: id};
                        dataArray.push(obj);
                    });
                    const orderResult = Order(dataArray, 'hour');
                    const routesResult = Filters(orderResult, 'routeName', reverseRoute);
                    const daysResult = Filters(routesResult, 'days', valueDays);
                    const uniqueObjects = [...new Map(daysResult.map(item => [item.days, item])).values()];
                    const hourResult = daysResult.filter(time => time.hour >= newHour);

                    console.log(hourResult)

                    if (hourResult.length === 0) {
                        setValueRoutes('');
                        setValueDays('');
                        setNextHour('');
                    }
                    if (uniqueObjects.length > 0 && newHour > e.value) {
                        // setDataDays(uniqueObjects);
                        setDataHour(hourResult);
                        setValueDays(uniqueObjects[0].days);
                    } else {
                        setValueRoutes('');
                        setValueDays('');
                        setNextHour('');
                    }
                })
                .catch(function () {
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                });
        }
    };

    /* Lista Rutas y horarios*/
    const routesSchedulesList = () => {
        return (
            <div>
                <Element name="list-element" className="element"/>
                <RoutesSchedulesList data={dataList} setDataList={setDataList} dataHour={dataHour}
                                     setDataDays={setDataDays} setDataHour={setDataHour}
                />
            </div>
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (dataList.length > 0) {
            setAlert(false)
            if (imageVehicleAsUrl) {
                setAlertImage(false)

                setShowPanel(true);

                const password = MakePwd(6);

                const docId = Filters(typeVehicle, 'typeVehicle', dataVehicle.typeVehicle);

                const newDataObjVehicle = {...dataVehicle, docId: docId[0].docId};

                const newDataObjDriver = {
                    ...dataDrivers,
                    password: password,
                    companyName,
                    imageAsUrl,
                    contactNumbers
                };

                newDataObjVehicle.dataRoutesSchedule = dataList;
                newDataObjVehicle.imageVehicle = imageVehicleAsUrl;

                delete newDataObjVehicle.route;
                delete newDataObjVehicle.day;
                delete newDataObjVehicle.hour;

                newDataObjDriver.vehicleData = newDataObjVehicle;

                const {instance} = dxForm.current;


                console.log(newDataObjDriver)

                await axios.post(url, newDataObjDriver, {headers: headers})
                    .then(res => {
                        console.log(res.data)
                        if (res.data === 'OK') {
                            setSuccess(true)
                            setShowPanel(false);
                            setTrigger(!trigger)
                            ControlStore.getDriversFinished(true)
                            customScroll('bottom-element', 700)
                            setTimeout(() => {
                                instance.resetValues();
                                setSuccess(false)
                                setVisibleGrid(true)
                                setVisibleForm(false)
                                setDataList([]);
                                setFilePhoto('');
                                setDataDrivers(null);
                            }, 2000)
                        } else {
                            setShowPanel(false);
                            NotiStackInfo('El usuario ya se encuentra registrado', 'error', enqueueSnackbar)
                        }
                    }).catch((e) => {
                        console.log(e)
                        setShowPanel(false);
                        NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                    })
            } else {
                customScroll('image-element', 500)
                setAlertImage(true)
            }
        } else {
            setAlert(true)
            setTextAlert('Debe agregar al menos una ruta a la lista para guardar los datos.')
        }
    }

    return (
        <>
            <Element name="image-element" className="element"/>
            <form action="" onSubmit={handleSubmit}>
                <Form
                    ref={dxForm}
                    formData={dataVehicle}
                    readOnly={false}
                    showColonAfterLabel={true}
                    showValidationSummary={true}
                    validationGroup="forms-vehicles"
                >
                    <GroupItem caption="Foto del vehículo" colCount={2}>
                        <SimpleItem render={imageVehicleRender}/>
                        <SimpleItem render={uploadVehiclePhoto}/>
                    </GroupItem>
                    <GroupItem caption={'Datos del vehículo'} colCount={1}>
                        <SimpleItem dataField="brand" label={{text: 'Marca'}} editorType="dxSelectBox"
                                    editorOptions={{
                                        items: vehiclesBrands,
                                        searchEnabled: true,
                                        placeholder: 'Seleccionar...',
                                    }}>
                            <RequiredRule message="Escoja la marca del vehículo."/>
                        </SimpleItem>

                        <SimpleItem dataField="model" label={{text: 'Modelo'}} editorOptions={{maxLength: 25}}>
                            <RequiredRule message="Ingrese el modelo"/>
                        </SimpleItem>

                        <SimpleItem dataField="color" label={{text: 'Color'}} editorOptions={{maxLength: 25}}>
                            <RequiredRule message="Color del vehículo"/>
                        </SimpleItem>

                        <SimpleItem dataField="plateNumber" label={{text: 'Número de placa'}}
                                    editorOptions={{
                                        maxLength: 10,
                                        elementAttr: {class: 'uppercase'},
                                    }}>
                            <RequiredRule message="Ingrese la placa"/>
                            <AsyncRule
                                message={'Este numero de placa ya a sido registrada o existe un error en los dígitos'}
                                validationCallback={asyncValidation}/>
                        </SimpleItem>

                        <SimpleItem dataField="typeVehicle" label={{text: 'Tipo de vehículo'}}
                                    editorType="dxSelectBox"
                                    editorOptions={{
                                        dataSource: typeVehicle,
                                        displayExpr: 'typeVehicle',
                                        valueExpr: 'typeVehicle',
                                        searchEnabled: true,
                                        placeholder: 'Seleccionar...',
                                        onValueChanged: onValueChangedVehicle
                                    }}>
                            <RequiredRule message="Seleccione el tpo de vehículo"/>
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem caption={'Asignación de rutas y horarios'} colCount={1}>
                        <SimpleItem dataField={'route'} label={{text: 'Rutas'}} editorType="dxSelectBox"
                                    editorOptions={{
                                        dataSource: routesSchedules,
                                        displayExpr: 'routeName',
                                        valueExpr: 'routeName',
                                        searchEnabled: true,
                                        placeholder: 'Seleccionar...',
                                        value: valueRoutes,
                                        onValueChanged: onValueChanged,
                                    }}/>

                        <SimpleItem dataField={'day'} label={{text: 'Día'}} editorType="dxSelectBox"
                                    editorOptions={{
                                        dataSource: dataDays,
                                        displayExpr: 'days',
                                        valueExpr: 'days',
                                        searchEnabled: true,
                                        placeholder: 'Seleccionar...',
                                        value: valueDays,
                                        onValueChanged: onValueChangedDays,
                                    }}/>

                        <SimpleItem dataField={'hour'} label={{text: 'Hora'}} editorType="dxSelectBox"
                                    editorOptions={{
                                        dataSource: dataHour,
                                        value: valueHour,
                                        displayExpr: 'hour',
                                        valueExpr: 'hour',
                                        searchEnabled: true,
                                        placeholder: 'Seleccionar...',
                                        onValueChanged: onValueChangedHours,
                                    }}/>
                    </GroupItem>
                    <GroupItem caption={'Lista'} colCount={1}>
                        <SimpleItem render={routesSchedulesList}/>
                        {alert && <SimpleItem render={renderAlert}/>}
                        {success && <SimpleItem render={renderSuccess}/>}
                    </GroupItem>
                    <GroupItem colCount={2}>
                        <SimpleItem render={renderCancelButton}/>
                        <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                    </GroupItem>
                </Form>
            </form>
            <Element name="bottom-element" className="element"/>
            <ComponentLoadPanel showLoadPanel={showPanel} time={3000} message={'Creando conductor...'}/>
        </>
    )
}

export default VehicleForm

function timeConvert(n) {
    let hours = (n / 60);
    let rhours = Math.floor(hours);
    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);
    return {hours: rhours, minutes: rminutes};
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
}));
